import React, { useContext } from 'react';
import S from "./PortfolioStatistics";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index";
import moment from 'moment';

const PortfolioStatistics: React.FC<FundSingle> = () => {
    const { fundRiskDetails } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;

    var tableValues = {};

    var portfolio = fundRiskDetails.Portfolios[0];
    var portfolioDate = moment(portfolio.Date).format('YYYY-MM-DD');

    tableValues["% av fondförmögenheten i fondens tio största placeringar"] = [portfolio.PercAssetsTop10Holdings.toFixed(2)];
    tableValues["Totalt antal räntebärande värdepapper"] = [portfolio.HoldingAggregates[0].NumberOfHolding];
    tableValues["Totalt antal aktieinnehav"] = [portfolio.HoldingAggregates[1].NumberOfHolding];

    var tableData = {
        headings: [],
        rows: tableValues
    }

    return (
        <S.AllocationWrapper>
            <CardHeader title="Portföljstatistik" subTitle={portfolioDate} />
            <Table tableData={tableData} />
        </S.AllocationWrapper>
    );
};

export default PortfolioStatistics;
